<template>
  <div class="homework-detail-wrap">
    <el-collapse v-model="activeNames">
      <el-collapse-item :name="0">
        <template slot="title"
          ><div class="homework-name">
            {{ workInfo.homework_name }}
          </div></template
        >
        <div class="work-info-wrap" :style="handleWorkInfoStyle" ref="workInfo">
          <div class="work-cont" v-html="questionInfo.content"></div>
          <div v-if="workInfo?.accessory?.length" class="material-wrap">
            <div class="top-wrap">
              <p class="cont-title">附件内容</p>
              <button @click="downloadAllFile" class="download-btn">
                <span>下载全部</span
                ><img
                  src="../../../assets/images/homework-custom/download-icon.png"
                  alt=""
                />
              </button>
            </div>

            <ul class="material-list">
              <li
                @click="downloadFile(item)"
                class="material-item"
                v-for="item in workInfo.accessory"
                :key="item.id"
              >
                <img class="icon" :src="fileTypeIcon(item)" alt="" />
                <div class="file-info">
                  <p class="name">{{ item.material_name + item.file_ext }}</p>
                  <p class="size">{{ handleFilesize(item.file_size) }}</p>
                </div>
                <div>
                  <button class="download-btn">下载</button>
                </div>
              </li>
            </ul>
          </div>
          <!-- 已提交-作业答案 -->
          <div v-if="questionInfo.answer_example" class="answer-example-wrap">
            <p class="cont-title">作业答案</p>
            <div
              class="answer-example"
              v-html="questionInfo.answer_example"
            ></div>
          </div>
        </div>
        <!-- 展开和收起 -->
        <div
          v-if="canShowAllInfo"
          class="show-all-info"
          :class="{
            isExpand: expand,
          }"
        >
          <button @click="handleExpand">
            <i v-if="expand" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { fileImagebyFileName, handleFilesize } from "@saas/components";
export default {
  props: {
    workInfo: {
      type: Object,
      default: () => {},
    },
    questionInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeNames: [0],
      canShowAllInfo: false,
      expand: false,
    };
  },
  methods: {
    handleFilesize,
    handleExpand() {
      this.expand = !this.expand;
    },
    downloadAllFile() {
      (this?.workInfo?.accessory || []).forEach((item, index) => {
        this.downloadFile(item);
      });
    },
    downloadFile(item) {
      const { url } = item;
      if (window.isElectron) {
        window.openUrlByExternal(url);
      } else {
        window.open(url);
      }
    },
  },
  computed: {
    fileTypeIcon() {
      return (item) => {
        if ([".jpg", ".jpeg", ".png", ".gif", ".bmp"].includes(item.file_ext)) {
          return (
            item.url +
            (item.url.indexOf("?") > -1 ? "&" : "?") +
            "imageView2/0/w/50"
          );
        } else {
          const name = item.material_name + item.file_ext;
          return fileImagebyFileName(name);
        }
      };
    },
    handleWorkInfoStyle() {
      return {
        maxHeight: this.expand ? "none" : "300px",
      };
    },
  },
  watch: {
    questionInfo: {
      immediate: true,
      handler(val) {
        if (val.content) {
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$refs["workInfo"]) {
                this.canShowAllInfo =
                  this.$refs["workInfo"].offsetHeight >= 300;
              }
            }, 500);
          });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-detail-wrap {
  position: relative;
  .work-info-wrap {
    max-height: 300px;
    overflow: hidden;
  }
  .show-all-info {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 27px;
    border-radius: 0 0 8px 8px;
    background: linear-gradient(
      180deg,
      rgba(250, 250, 251, 0) 0%,
      #f2f3f5 100%
    );
    &.isExpand {
      background: transparent;
    }
    button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      width: 20px;
      height: 20px;
      background: #ffffff;
      box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
      border-radius: 6px;
      border: 1px solid #e5e6e8;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        transition: transform 0.3s;
        color: #4e5969;
        font-weight: bold;
      }
    }
  }
  .work-cont {
    font-size: 14px;
    padding: 0 16px 0;
  }
  .material-wrap {
    border-top: 1px solid #f2f3f5;
    // padding: 12px 16px 10px;
    .top-wrap {
      display: flex;
      justify-content: space-between;
      padding: 12px 16px 10px;
    }
    .cont-title {
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
    }
    .download-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 16px;
      color: #00c89d;
      line-height: 22px;
      img {
        width: 16px;
        height: 16px;
        margin-left: 6px;
      }
    }
  }
  .material-list {
    display: flex;
    flex-wrap: wrap;
    // margin-bottom: 1opx;
    .material-item {
      width: 260px;
      height: 64px;
      border-radius: 8px;
      border: 1px solid #f2f3f5;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 0 14px 0 10px;
      margin-left: 12px;
      margin-bottom: 12px;
      img {
        width: 34px;
        height: 34px;
        margin-right: 12px;
        border-radius: 4px;
      }
      .name {
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 17px;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .size {
        font-weight: 400;
        font-size: 11px;
        color: #747573;
        line-height: 16px;
      }
      .file-info {
        flex: 1;
        width: 0;
      }
      .download-btn {
        font-weight: 400;
        font-size: 14px;
        color: #00c89d;
        line-height: 20px;
        margin-left: 8px;
      }
    }
  }
  .answer-example-wrap {
    margin: 0 12px;
    background: #f7f8fa;
    border-radius: 12px;
    .cont-title {
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      padding: 12px 12px 10px;
    }
    .answer-example {
      font-size: 14px;
      color: #0d1400;
      padding: 0 12px 12px;
    }
  }
}

::v-deep .el-collapse {
  // margin-top: 13px;
  border: none;
  .homework-name {
    white-space: nowrap;
    line-break: anywhere;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
  }
  .el-collapse-item__header {
    height: 54px;
    border: none;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px 6px 16px 16px;
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.is-active {
      padding-bottom: 12px;
    }
  }
  .el-collapse-item {
    border-radius: 8px;
    // border: none;
    border: 1px solid #f2f3f5;
  }
  .el-collapse-item__content {
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    line-height: 26px;
    padding: 0;
    border-radius: 8px;
    line-break: anywhere;
    padding-bottom: 12px;
  }
  .el-collapse-item__arrow {
    width: 14px;
    height: 14px;
    background: #ffffff;
    position: relative;
    &::before {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .el-collapse-item__wrap {
    border-bottom: 0;
    border-radius: 8px;
  }
  .el-collapse-item__arrow.el-icon-arrow-right.is-active {
    transform: rotate(-90deg);
  }
  .el-collapse-item__arrow.el-icon-arrow-right {
    transform: rotate(90deg);
  }
}
</style>
